import { mapArrayToRecord, PartialRecord } from "@base/util/TypeUtil";
import { IArticleWithCount, IRuleArticle, RuleArticleMap } from "@biz/definitions/ArticleDefinitions";
import { PoleId } from "@biz/definitions/SunSailDefinitions";
import { QuickCategory } from "@biz/models/ShoppingListDefinitions";

export class RuleArticleHelper {
  static findPoleArticles(ruleArticles: RuleArticleMap, articlesToFind: readonly string[], poleIndex: PoleId | undefined | -1): string[] {
    const ret: string[] = [];
    const articlesMapToFind = mapArrayToRecord(articlesToFind, (item) => item);
    const shoppingListKeys = Object.keys(ruleArticles);
    for (const id of shoppingListKeys) {
      const article = ruleArticles[id];
      if (poleIndex !== undefined) {
        const pi = article.affiliation?.poleId !== undefined ? article.affiliation.poleId : -1;
        if (pi !== poleIndex)
          continue;
      }
      const foundWinch = articlesMapToFind[article.articleNumber];
      if (foundWinch) {
        if (article.count > 0)
          ret.push(article.articleNumber)
      }
    }
    return ret;
  }

  static countArticles(ruleArticles: RuleArticleMap, articlesToFind: string[], poleId: PoleId | undefined): { totalCount: number, foundArticles: IArticleWithCount[] } {
    let totalCount = 0;
    const foundArticles: IArticleWithCount[] = [];
    const articlesMapToFind = mapArrayToRecord(articlesToFind, (item) => item);
    const shoppingListKeys = Object.keys(ruleArticles);
    for (const id of shoppingListKeys) {
      const article = ruleArticles[id];
      const pi = article.affiliation?.poleId !== undefined ? article.affiliation.poleId : -1;
      if (poleId !== undefined && pi !== poleId)
        continue;
      const foundWinch = articlesMapToFind[article.articleNumber];
      if (foundWinch) {
        if (article.count > 0) {
          totalCount += article.count;
          foundArticles.push({ articleNumber: article.articleNumber, count: article.count })
        }
      }
    }
    return {
      totalCount,
      foundArticles
    };
  }

  static groupBy<T>(this: void, record: Record<string, T>, getCategory: (item: T) => string): Record<string, Record<string, T>> {
    const ret: Record<string, Record<string, T>> = {};
    const keys = Object.keys(record);
    for (const k of keys) {
      const item = record[k];
      const cat = getCategory(item);
      if (!ret[cat])
        ret[cat] = {};
      ret[cat][k] = item;
    }
    return ret;
  }

  static getRuleArticle(this: void, articleMap: RuleArticleMap | undefined, articleId: string): IRuleArticle | undefined {
    if (!articleMap)
      return undefined;
    return articleMap[articleId];
  }

  static group(articles: RuleArticleMap | undefined): PartialRecord<QuickCategory, RuleArticleMap> {
    if (!articles) return {};
    return RuleArticleHelper.groupBy(articles, (item) => item.affiliation?.quickCategory || "noCategory");
  }

  static getGranularity(ruleArticle: IRuleArticle): number {
    return ruleArticle.granularity ?? 1;
  }

  static getMinUnits(ruleArticle: IRuleArticle): number {
    return ruleArticle.articleType === "obligatory" ? ruleArticle.count * RuleArticleHelper.getGranularity(ruleArticle) : 0;
  }

  static getMaxUnits(ruleArticle: IRuleArticle): number {
    return ruleArticle.maxUnits ?? Infinity;
  }
}